import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=0867ee5f"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0867ee5f')) {
      api.createRecord('0867ee5f', component.options)
    } else {
      api.reload('0867ee5f', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=0867ee5f", function () {
      api.rerender('0867ee5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/BarChart.vue"
export default component.exports